export const rootPath = "";

export const API_NUEVO_CANAL = "API_NUEVO_CANAL";
export const API_CANAL = "API_CANAL";
export const API_ONE_STEP = "API_ONE_STEP";
export const API_CANAL_AMI = "API_CANAL_AMI";

export const ERROR_CODE_NOT_FOUND = "000013";
export const ERROR_CODE_NETWORK_ERROR = "000000";

export const StateMachine = {
  0: "Start",
  1: "Continue",
  4: "Error Api",
  5: "Error Dps Si",
  6: "Error Mayor 64",
  7: "Error Biometrico",
  8: "End Flow",
  9: "Not Register",
};

export const UIStateMachine = {
  0: "Start",
  1: "Show Loading",
  2: "Hide Loading",
};
